{
    "sely": {
        "tip": "",
        "moment": "",
        "pair": "mom",
        "local": ["", ""],
        "live": ["5DMiB00rWUNviWzcMTd9I7vacVi1", "6BN6kXoIj9dR1KaNdeXiY1cj02K3"]
    },
    "dad": {
        "tip": "",
        "moment": "",
        "pair": "thonly",
        "local": ["", ""],
        "live": ["5DMiB00rWUNviWzcMTd9I7vacVi1", "DNVeu0ZmNjPQD87rpOspEiCJmsf1"]
    },
    "mom": {
        "tip": "Thanks so much Mom for the food 😋",
        "moment": "Thanks @mom for cooking food for the family 👩🏻‍🍳",
        "pair": "thonly",
        "local": ["", ""],
        "live": ["6BN6kXoIj9dR1KaNdeXiY1cj02K3", "DNVeu0ZmNjPQD87rpOspEiCJmsf1"]
    },
    "kim": {
        "tip": "",
        "moment": "",
        "pair": "bee",
        "local": ["", ""],
        "live": ["l8btTniUMVNUZDNZtDeTQRRZn1a2", "VcRoxlu7psfp4au8NxkJ2Vjadzg1"]
    },
    "thonly": {
        "tip": "Thanks so much Thon for washing my dishes",
        "moment": "Thanks @thonly for washing the dishes for everyone 🧼",
        "pair": "kim",
        "local": [
            "FH0StluAUK0Yl0PkvMv64wa949VG",
            "zzfhYxpXFbIentWQYYeu0kftV6kP"
        ],
        "live": ["DNVeu0ZmNjPQD87rpOspEiCJmsf1", "l8btTniUMVNUZDNZtDeTQRRZn1a2"]
    },
    "thien": {
        "tip": "",
        "moment": "",
        "pair": "",
        "local": ["", ""],
        "live": ["ck5dN4R57tNN8caLlFmyLwTUjSC2", ""]
    },
    "chengsieuly": {
        "tip": "",
        "moment": "",
        "pair": "jenieva",
        "local": ["", ""],
        "live": ["ab1Z5s3r5IY8wxlCPvKDzB2exdt1", "ISUi8KDDYWRPncB1dFkKome6wVf1"]
    },
    "bee": {
        "tip": "",
        "moment": "",
        "pair": "",
        "local": ["", ""],
        "live": ["VcRoxlu7psfp4au8NxkJ2Vjadzg1", ""]
    }
}
